import AgentRead from 'models/agent_read';
import createConverter from './lib/create_converter';

export default createConverter(AgentRead);
